import Util from '../forecast-app/shared/util/util';
import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import {trackEvent} from '../tracking/amplitude/TrackingV2';
import {BulkCreateDepartmentsInput} from './__generated__/bulkCreateDepartmentsMutation.graphql';
import {createRangeBulkAddUpdater} from '../relay-helpers/RelayCacheHelpers';

const mutation = graphql`
	mutation bulkCreateDepartmentsMutation($input: BulkCreateDepartmentsInput!) {
		bulkCreateDepartments(input: $input) {
			departments {
				node {
					id
					name
				}
			}
			errors
		}
	}
`;

function commit(
	environment: Environment,
	input: BulkCreateDepartmentsInput,
	onSuccess?: (response) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Departmetns', 'Bulk Created', input);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation(environment, {
		mutation,
		variables,
		updater: createRangeBulkAddUpdater(
			input.companyId || '',
			'bulkCreateDepartments',
			'departments',
			'Company_departments'
		),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
